@import '../../../../constants/spacing.module.less';

.sidebar {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: var(--white);
  border-right: 1px solid var(--default--border-color--12);
}

.sidebar-items {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.sidebar-group-header {
  padding: @space-8 @space-12 @space-4;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.sidebar-field-item {
  overflow-y: auto;
  display: block;
  width: 100%;
  text-align: left;
  padding: @space-4 @space-12 @space-4 @space-32;
  font-size: 13px;
  color: var(--grey-800);
  cursor: pointer;
  line-height: 1.4;
}

.sidebar-field-item:hover {
  background-color: var(--grey-100);
}

.sidebar-field-item:active {
  background-color: var(--grey-200);
}

.sidebar-subgroup {
  padding-left: @space-16;
}

.sidebar-items > .sidebar-subgroup {
  padding-left: 0;
}

.sidebar-subgroup-header {
  padding: @space-4 @space-8;
  flex-wrap: nowrap;
  align-items: center;
}

.sidebar-subgroup-header:hover {
  background-color: var(--grey-100);
}

.sidebar-subgroup-header:active {
  background-color: var(--grey-200);
}

.sidebar-subgroup-toggle {
  padding: 0 @space-4;
  flex-shrink: 0;
}

.sidebar-subgroup-container {
  align-items: center;
}

.sidebar-subgroup-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--grey-900);
  text-align: left;
}

.sidebar-subgroup-arrow {
  font-size: 10px;
  transition: transform 0.2s ease;
}

.sidebar-subgroup-arrow-open {
  transform: rotate(90deg);
}

.sidebar-subgroup-content {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.2s ease;
}

.sidebar-subgroup-content-open {
  grid-template-rows: 1fr;
}

.sidebar-subgroup-content-inner {
  overflow: hidden;
  min-height: 0;
}

.sidebar-field-description {
  display: block;
  font-size: 11px;
  font-weight: 400;
  color: var(--grey-500);
  line-height: 1.3;
}

.sidebar-tooltip-content {
  padding: @space-4 @space-8;
  max-width: 200px;
  font-size: 11px;
  font-weight: 400;
  line-height: 1.3;
}

div:has(> .sidebar-tooltip-content.sidebar-tooltip-content) {
  transform: translate(calc(-50% - 30px), calc(-100% + 15px));
}
.sidebar-tooltip-content.sidebar-tooltip-content > div {
  border-width: 5px;
}
